import ManageParticipant from "./index";
import React from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../../shared/context/auth";
import { useQueryClient } from "react-query";
import { refreshDashboardData } from "../../context/dashboard/dataloader";
import useNavigateWrapper from "../../../../shared/hooks/useNavigateWrapper";
import { MyExpRoute } from "../../routes/types";

export default function ManageParticipantWrapper() {
  const { navigate } = useNavigateWrapper();
  const { programParticipantId } = useParams();
  const { userDetail } = useAuth();
  const queryClient = useQueryClient();

  const onCloseHandler = React.useCallback(() => {
    refreshDashboardData(queryClient, userDetail?.id);
    navigate(MyExpRoute.HOME.path);
  }, [navigate, queryClient, userDetail?.id]);

  return <ManageParticipant programParticipantId={programParticipantId} closeHandler={onCloseHandler} />;
}
